import { mapDataSource, RawDataSource } from '~/Api/DataSource';

import { ComparativePriceProduct } from './ComparativePriceProduct';

export interface RawComparativePriceProduct {
	readonly id: string;
	readonly dataSource: RawDataSource;
}

export const mapComparativePriceProduct = (product: RawComparativePriceProduct) =>
	new ComparativePriceProduct(product.id, mapDataSource(product.dataSource));
